<template>
  <div
    class="padding-wrapper"
    :class="{ btn: !isFinish && !isNoAction }"
    :style="{ background: processBg }"
  >
    <div class="process" @click="handleUserAction">
      <div class="title" :class="{ bolder: config.desc }">
        {{ config.button }}
      </div>
      <div v-if="config.desc" class="desc">{{ config.desc }}</div>
      <img
        v-if="!isFinish && !isNoAction"
        class="arrow"
        src="../assets/arrow-right.svg"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
const eventMap: any = {
  assistant: 'success-modal',
  subscribe: 'success-modal',
  guide: 'go-url',
  collect: 'go-url',
  waiting: 'go-url',
  mobile: 'validate',
};
@Component({})
export default class Process extends Vue {
  @Prop() config!: any;
  @Prop() type!: string;
  @Prop({ type: Boolean, default: false }) isFinish!: boolean;
  @Prop({ type: Boolean }) isNoAction!: boolean;
  @Prop({ type: String, default: 'linear-gradient(to left, #fe729f, #6740f1)' })
  processBg!: string;
  handleUserAction() {
    const event = eventMap[this.type];
    if (event && !this.isNoAction) {
      this.$emit(event, this.config);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/helps.scss';
.process {
  @include flex-center;
  position: relative;
  flex-direction: column;
  box-sizing: content-box;
  width: 100%;
  height: 128px;
  color: #fff;
  .title {
    font-weight: 500;
    font-size: 34px;
    &.bolder {
      font-size: 40px;
    }
  }
  .desc {
    color: rgba($color: #fff, $alpha: 0.8);
    font-size: 20px;
  }
  .arrow {
    position: absolute;
    top: 50%;
    right: 24px;
    width: 40px;
    height: 40px;
    transform: translate(0, -50%);
  }
}
.padding-wrapper {
  margin-top: -1px;
  @include ios-bottom(padding-bottom);
  background: linear-gradient(to left, #fe729f, #6740f1);
  &.btn {
    @include button;
  }
}
</style>
